// extracted by mini-css-extract-plugin
export default {"image":"J3-z","loaded":"K3-z"};